<script>
  import Icon from '$components/ui/icon/icon.svelte';
</script>

<div
  class="flex size-18 flex-shrink-0 items-center justify-center rounded-full bg-foreground text-background"
>
  <Icon icon="check" size={16} />
</div>
